import { ProgressBar } from "react-bootstrap";

const Loader = ({processed, total}) => {
	let perc = Math.round(processed/total*100)
	return <ProgressBar label={`${perc}%`} now={perc} />
}

export default Loader;